import { render, staticRenderFns } from "./TrainingsUsersRead.vue?vue&type=template&id=3a8f1ef4"
import script from "./TrainingsUsersRead.vue?vue&type=script&lang=js"
export * from "./TrainingsUsersRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports